import React, { useState, useEffect, useCallback } from 'react';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import '../../CSS/style.css';
import { connect } from 'react-redux';
import { DatePicker, Radio, Select } from 'antd';
import { DatePickerSlider } from '../../../ChartComponents/CSS/style';

dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);

const { Option } = Select;
const { WeekPicker } = DatePicker;

const DayMonthYearSelection = (props) => {
    const { translationCache, headerJSON, graphprops } = props;
    const selectionPoint = headerJSON?.DashboardLevelSelectionPoint === 'PreviousDay' ? 1 : 0;
    

    const [state, setState] = useState({
        currentDate: dayjs().subtract(selectionPoint, 'day'),
        currentYear: null,
        endDate: dayjs(),
        week: dayjs().startOf('week'),
        month: dayjs().format('MMMM'),
        year: dayjs().year(),
        currentTab: '',
        payload: null
    });
    const [yearList, setYearList] = useState([]);

    useEffect(() => {
        const timeBucketObject = props.headerJSON?.TimeBucket || {};
        const currentTab = Object.keys(timeBucketObject)[0] || '';
        setState(prevState => ({ ...prevState, currentTab }));
    }, [props.headerJSON]);

    useEffect(() => {
        // Generate year list: from current year down to 2000
        const years = [];
        const currentYearVal = dayjs().year();
        for (let i = currentYearVal; i >= 2000; i--) {
            years.push(i);
        }
        setYearList(years);

        // Set initial current tab
        const timeBucketObject = props.headerJSON?.TimeBucket || {};
        const initialTab = Object.keys(timeBucketObject)[0] || '';
        setState(prev => ({ ...prev, currentTab: initialTab }));
    }, [props.headerJSON]);

    const translation = useCallback((keyword) => {
        return translationCache?.[keyword] || keyword;
    }, [translationCache]);

    const disabledDate = (current) => {
        return current && current.isAfter(dayjs().startOf('day'));
    };

    const onChange = (date) => {
        if (!date) return;

        const startDateSelected = dayjs(date).startOf('day').format('YYYY-MM-DD HH:mm:ss');
        const endDateSelected = dayjs(date).endOf('day').format('YYYY-MM-DD HH:mm:ss');

        const payload = {
            StartDate: startDateSelected,
            EndDate: endDateSelected,
            TimeBucket: props.dashboards?.TimeBucket?.['Day'] || '',
            SelectionType: 'Day'
        };

        setState(prevState => ({
            ...prevState,
            currentDate: date,
            payload
        }));

        props.selectionpayload(payload);
    };

    const onRadioChange = (e) => {
        const value = e.target.value;
        const currentDate = dayjs();

        if (value === 'Month') {
            const currentMonth = currentDate.format('MMMM');
            const currentYear = currentDate.year();
            setState(prevState => ({
                ...prevState,
                currentTab: value,
                month: currentMonth,
                year: currentYear
            }));
            handleMenuClick(currentMonth, 'Month', 'default');
        } else if (value === 'Year') {
            const yearValue = currentDate.year();
            setState(prevState => ({
                ...prevState,
                currentTab: value,
                year: yearValue
            }));
            handleMenuClick(yearValue, 'Year', 'default');
        } else if (value === 'Week') {
            const currentWeek = currentDate.startOf('isoWeek');
            setState(prevState => ({
                ...prevState,
                currentTab: value,
                week: currentWeek
            }));
            handleMenuClick(currentWeek, 'Week', 'default');
        } else {
            onChange(currentDate);
            setState(prevState => ({
                ...prevState,
                currentTab: value
            }));
        }
    };

    const handleMenuClick = (value, parent) => {
        const DashboardLevelSelectionPoint = graphprops?.DashboardLevelSelectionPoint === 'PreviousDay' ? 1 : 0;
        const timeBucketObject = props.dashboards?.TimeBucket || {};

        let payload;

        if (parent === 'Month') {
            const selectedMonth = dayjs(value, 'MMMM').month();
            const currentYearVal = dayjs().year();

            const startDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').startOf('month');
            let endDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').endOf('month');

            if (
                currentYearVal === dayjs().year() &&
                selectedMonth === dayjs().month()
            ) {
                endDate = dayjs().subtract(DashboardLevelSelectionPoint, 'day');
            }

            const payload = {
                StartDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
                EndDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
                TimeBucket: timeBucketObject['Month'],
                SelectionType: 'Month'
            };
            setState(prevState => ({
                ...prevState,
                payload,
                month: value
            }));
            props.selectionpayload(payload);
        } else if (parent === 'Year') {
            const startDate = dayjs(`${value}-01-01`).startOf('year');
            let endDate = dayjs(`${value}-12-31`).endOf('year');

            if (value === dayjs().year()) {
                endDate = dayjs().subtract(DashboardLevelSelectionPoint, 'day');
            }

            const payload = {
                StartDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
                EndDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
                TimeBucket: timeBucketObject['Year'],
                SelectionType: 'Year'
            };
            setState(prevState => ({
                ...prevState,
                payload,
                currentYear: value,
                year: value
            }));
            props.selectionpayload(payload);
        } else if (parent === 'Week') {
            const startDate = dayjs(value).startOf('week');
            let endDate = dayjs(value).endOf('week');
            const currentWeek = dayjs().startOf('isoWeek');

            if (dayjs(value).isSame(currentWeek)) {
                endDate = dayjs().subtract(DashboardLevelSelectionPoint, 'day');
            }

            payload = {
                StartDate: startDate.format('YYYY-MM-DD HH:mm:ss'),
                EndDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
                TimeBucket: timeBucketObject['Week'],
                SelectionType: 'Week'
            };
            setState(prevState => ({
                ...prevState,
                payload,
                week: dayjs(value).startOf('week')
            }));
            props.selectionpayload(payload);
        }
    };

    const timeBucketArray = headerJSON?.TimeBucket || {};
    const { currentTab, currentDate, week, month, year } = state;

    return (
        <div style={{ height: '70%', marginTop: '10px' }}>
            <DatePickerSlider>
                <Radio.Group
                    value={currentTab}
                    onChange={onRadioChange}
                    style={{ marginLeft: '20px' }}
                >
                    {timeBucketArray['Day'] && (
                        <Radio.Button value="Day">{translation('Day')}</Radio.Button>
                    )}
                    {timeBucketArray['Week'] && (
                        <Radio.Button value="Week">{translation('Week')}</Radio.Button>
                    )}
                    {timeBucketArray['Month'] && (
                        <Radio.Button value="Month">{translation('Month')}</Radio.Button>
                    )}
                    {timeBucketArray['Year'] && (
                        <Radio.Button value="Year">{translation('Year')}</Radio.Button>
                    )}
                </Radio.Group>

                {currentTab === 'Day' && (
                    <DatePicker
                        onChange={onChange}
                        value={currentDate}
                        disabledDate={disabledDate}
                        allowClear={false}
                    />
                )}

                {currentTab === 'Week' && (
                    <WeekPicker
                        value={week}
                        style={{ width: '200px' }}
                        disabledDate={disabledDate}
                        placeholder="Select Week"
                        allowClear={false}
                        onChange={(e) => handleMenuClick(e, 'Week')}
                    />
                )}

                {currentTab === 'Month' && (
                    <Select
                        value={month}
                        onChange={(e) => handleMenuClick(e, 'Month')}
                        style={{ width: '100px' }}
                    >
                        {dayjs.months().map((value, index) => (
                            <Option key={index} value={value}>
                                {value}
                            </Option>
                        ))}
                    </Select>
                )}
                {(currentTab === 'Year' || currentTab === 'Month') && (
                    <Select
                        value={year}
                        onChange={(e) => handleMenuClick(e, currentTab)}
                        style={{ width: '100px' }}
                    >
                        {yearList.map((value, index) => (
                            <Option key={index} value={value}>
                                {value}
                            </Option>
                        ))}
                    </Select>
                )}
            </DatePickerSlider>
        </div>
    );
};

const mapStateToProps = (state) => ({
    translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(DayMonthYearSelection);

